import { Box, Typography } from "@mui/material";

import AuthIntegrationStrip from "./AuthIntegrationStrip";

export default function AuthBrandPanel({
  title,
  description,
  minHeight = "100vh",
  showIntegrations = true,
}) {
  return (
    <Box
      sx={(theme) => ({
        "--auth-brand-description-color":
          theme.palette.mode === "dark"
            ? theme.palette.custom.gray[600]
            : theme.palette.custom.gray[400],
        "--auth-brand-title-color":
          theme.palette.mode === "dark"
            ? theme.palette.custom.gray[900]
            : theme.palette.primary.contrastText,
        alignItems: "center",
        bgcolor: theme.palette.surface.inverse,
        color: "var(--auth-brand-title-color)",
        display: { xs: "none", md: "flex" },
        minHeight,
        overflow: "hidden",
        px: { md: 5, lg: 8, xl: 14 },
        py: { md: 5, lg: 8 },
      })}
    >
      <Box sx={{ maxWidth: 680, width: "100%" }}>
        <Typography
          component="h1"
          sx={(theme) => ({
            color: "var(--auth-brand-title-color)",
            fontSize: {
              md: theme.typography.h3.fontSize,
              lg: theme.typography.h2.fontSize,
              xl: theme.typography.h1.fontSize,
            },
            fontWeight: theme.typography.h1.fontWeight,
            letterSpacing: 0,
            lineHeight: 1.05,
            maxWidth: 660,
          })}
        >
          {title}
        </Typography>

        <Typography
          sx={(theme) => ({
            color: "var(--auth-brand-description-color)",
            fontSize: { md: 14, lg: 15, xl: 16 },
            lineHeight: 1.5,
            maxWidth: 672,
            mt: { md: 2.5, lg: 3 },
          })}
        >
          {description}
        </Typography>

        {showIntegrations ? <AuthIntegrationStrip /> : null}
      </Box>
    </Box>
  );
}
